import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { Layout, useBaseStore } from '@roc/feature-app-core';
import { Card, IconFilterButton, Toolbar } from '@roc/ui';
import { observer } from 'mobx-react';
import { MyExtensionsGrid } from '@roc/feature-loans';
import { useLoanStore } from '@roc/feature-loans';
import { useExtensionRequestStore } from 'libs/feature-loans/src/loans/loanDetails/modules/loanRequests/hooks/useExtensionRequestStore';
const useStyles = makeStyles(theme => ({
  container: {
    padding: 32,
  },
}));

export const LenderExtensionsDashboard = observer(() => {
  const classes = useStyles();
  const { loanStore } = useLoanStore();
  const { globalStore } = useBaseStore();
  const { extensionRequestStore } = useExtensionRequestStore();

  const gridStore = globalStore.showUnifiedLoans
    ? loanStore.unifiedMyExtensionsGridStore
    : extensionRequestStore.myExtensionsGridStore;

  const toolbar = (
    <Toolbar
      toolbarContainerStyle={{
        border: 0,
        padding: 0,
      }}
    >
      <IconFilterButton
        onToggleFilters={() => gridStore.toggleFilters()}
        onClearFilters={() => gridStore.resetFilters()}
        showFilters={gridStore.showFilters}
      />
    </Toolbar>
  );
  return (
    <Grid
      container
      direction="column"
      spacing={2}
      className={classes.container}
    >
      <Grid item>
        <Typography variant="h4">Extensions</Typography>
      </Grid>
      <Grid
        item
        style={{ display: 'flex', flexGrow: 1, flexDirection: 'column' }}
      >
        <MyExtensionsGrid toolbar={toolbar} />
      </Grid>
    </Grid>
  );
});
